/**
 * 兵法分支 (🗡️ 军事科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const BINGFA_TECHS: Tech[] = [
  // 第一层：基础兵法 (3项)
  {
    id: 'B001',
    name: '孙子十三篇',
    description: '兵法之祖，开启军事科技树',
    branch: 'bingfa',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { attackBonus: 1.05 },
    },
    position: { x: 20, y: 10 },
    icon: '📜',
  },
  {
    id: 'B002',
    name: '操练之法',
    description: '基础军事训练',
    branch: 'bingfa',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { trainSpeedBonus: 0.9 },
    },
    position: { x: 50, y: 10 },
    icon: '🎯',
  },
  {
    id: 'B003',
    name: '甲胄之术',
    description: '基础护甲研究',
    branch: 'bingfa',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { defenseBonus: 1.05 },
    },
    position: { x: 80, y: 10 },
    icon: '🛡️',
  },

  // 第二层：进阶兵法 (5项)
  {
    id: 'B011',
    name: '吴起兵法',
    description: '步战精要',
    branch: 'bingfa',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['B001'],
    effects: {
      bonuses: { swordAttack: 1.15, spearAttack: 1.15 },
    },
    position: { x: 10, y: 25 },
    icon: '⚔️',
  },
  {
    id: 'B012',
    name: '六韬三略',
    description: '骑战奥义',
    branch: 'bingfa',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['B001'],
    effects: {
      bonuses: { cavalryAttack: 1.15 },
    },
    position: { x: 30, y: 25 },
    icon: '🐎',
  },
  {
    id: 'B013',
    name: '百步穿杨',
    description: '射术精研',
    branch: 'bingfa',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['B001'],
    effects: {
      bonuses: { archerAttack: 1.15 },
    },
    position: { x: 50, y: 25 },
    icon: '🏹',
  },
  {
    id: 'B014',
    name: '精兵简练',
    description: '精英训练法',
    branch: 'bingfa',
    tier: 2,
    cost: 250,
    researchTime: 2.5,
    prerequisites: ['B002'],
    effects: {
      bonuses: { trainSpeedBonus: 0.8, unitHealthBonus: 1.1 },
    },
    position: { x: 70, y: 25 },
    icon: '💪',
  },
  {
    id: 'B015',
    name: '铁壁守御',
    description: '防御体系',
    branch: 'bingfa',
    tier: 2,
    cost: 250,
    researchTime: 2.5,
    prerequisites: ['B003'],
    effects: {
      bonuses: { defenseBonus: 1.1, repairSpeed: 1.15 },
    },
    position: { x: 90, y: 25 },
    icon: '🏯',
  },

  // 第三层：高级兵法 (5项)
  {
    id: 'B021',
    name: '三十六计',
    description: '诡道之术',
    branch: 'bingfa',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B011', 'B015'],
    effects: {
      bonuses: { attackBonus: 1.1, morale: 1.1 },
    },
    position: { x: 10, y: 45 },
    icon: '🎭',
  },
  {
    id: 'B022',
    name: '奔袭千里',
    description: '闪电战术',
    branch: 'bingfa',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B012'],
    effects: {
      bonuses: { cavalryAttack: 1.2, cavalryCharge: 1.2, speedBonus: 1.3 },
    },
    position: { x: 30, y: 45 },
    icon: '🌪️',
  },
  {
    id: 'B023',
    name: '连弩之阵',
    description: '诸葛连弩',
    branch: 'bingfa',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['B013'],
    effects: {
      bonuses: { archerAttack: 1.25, archerRange: 1.1 },
    },
    position: { x: 50, y: 45 },
    icon: '⚡',
  },
  {
    id: 'B024',
    name: '神机营法',
    description: '火药兵器',
    branch: 'bingfa',
    tier: 3,
    cost: 400,
    researchTime: 3.5,
    prerequisites: ['B013', 'B014'],
    effects: {
      bonuses: { archerAttack: 1.15, siegeBonus: 1.15 },
      special: { fireArrows: true },
    },
    position: { x: 70, y: 45 },
    icon: '🔥',
  },
  {
    id: 'B025',
    name: '不动如山',
    description: '绝对防御',
    branch: 'bingfa',
    tier: 3,
    cost: 400,
    researchTime: 3.5,
    prerequisites: ['B015'],
    effects: {
      bonuses: { defenseBonus: 1.5, shieldDefense: 1.3 },
    },
    position: { x: 90, y: 45 },
    icon: '⛰️',
  },

  // 第四层：大师兵法 (3项)
  {
    id: 'B031',
    name: '兵圣传承',
    description: '孙武真传',
    branch: 'bingfa',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['B021'],
    effects: {
      bonuses: { attackBonus: 1.15, researchSpeedBonus: 1.2 },
    },
    position: { x: 20, y: 65 },
    icon: '👑',
  },
  {
    id: 'B032',
    name: '战神之怒',
    description: '致命一击',
    branch: 'bingfa',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['B022', 'B024'],
    effects: {
      bonuses: { attackBonus: 1.2, cavalryCharge: 1.5 },
    },
    position: { x: 50, y: 65 },
    icon: '💀',
  },
  {
    id: 'B033',
    name: '金城汤池',
    description: '不落之城',
    branch: 'bingfa',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['B025'],
    effects: {
      bonuses: { defenseBonus: 1.5, repairSpeed: 1.5, upkeepReduction: 1.5 },
    },
    position: { x: 80, y: 65 },
    icon: '🏰',
  },

  // 第五层：终极兵法 (2项) [互斥]
  {
    id: 'B041',
    name: '天下无敌',
    description: '攻击终极：全军攻击+25%，无视10%敌方防御',
    branch: 'bingfa',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['B031', 'B032'],
    mutuallyExclusive: ['B042'],
    effects: {
      bonuses: { attackBonus: 1.25 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '🐉',
    quote: '善战者，致人而不致于人',
  },
  {
    id: 'B042',
    name: '固若金汤',
    description: '防御终极：全军防御+30%，受伤害时10%概率完全格挡',
    branch: 'bingfa',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['B031', 'B033'],
    mutuallyExclusive: ['B041'],
    effects: {
      bonuses: { defenseBonus: 1.3, shieldBlock: 1.1 },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '🐢',
    quote: '善守者，藏于九地之下',
  },
];
